export default {
  inserted(el, { arg }, { context }) {
    const container = arg ? document.getElementById(arg) : document.body;
    container.appendChild(el);
    context.$on('hook:beforeDestroy', function () {
      el.remove();
    });
  },
};
